import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuelidate from 'vuelidate'
import VueFlatPickr from 'vue-flatpickr-component'
import { i18n } from '@/plugins/i18n'
import Swal from 'vue-sweetalert2'
import { bootInterceptors } from '@/interceptors'

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'flatpickr/dist/flatpickr.css'

import '@/styles/main.scss'

Vue.use(BootstrapVue)
Vue.use(VueMaterial)
Vue.use(VueAxios, axios)
Vue.use(Vuelidate)
Vue.use(VueFlatPickr)
Vue.use(Swal)
Vue.use(Vuetify, {
    lang: { t: (key, ...params) => i18n.t(key, params) }
})

Vue.config.productionTip = false

// fix router error on material components when using to
// read https://github.com/vuejs/vue-router/issues/254
// Vue.use(router);
Vue.component('router-link', Vue.options.components.RouterLink)
Vue.component('router-view', Vue.options.components.RouterView)

bootInterceptors()

new Vue({
    router,
    i18n,
    store,
    axios,
    render: h => h(App)
}).$mount('#app')
